<!-- src/components/ModalHost.vue -->
<template>
  <Teleport to="body">
    <component
      v-for="modal in modals"
      :key="modal.id"
      :is="modal.component"
      v-bind="modal.props"
      @close="onClose(modal.id, $event)"
    />
  </Teleport>
</template>

<script setup>
import { useModalManager } from '@/composables/useModalManager'

const { modals, close } = useModalManager()

const onClose = (id, payload) => {
  close(id, payload)
}
</script>
